module.exports = __webpack_public_path__ + "img/caret-right-green.348cbe82.svg";